import {
  BooleanInput,
    Create,
    NullableBooleanInput,
    required,
    SelectInput,
    SimpleForm,
    TextInput,
  } from 'react-admin';
  
  export const ClergyCreate = () => (
    <Create>
      <SimpleForm>
      <SelectInput source="title" fullWidth helperText={false} choices={[
          { id: 'Rabbi', name: 'Rabbi' },
          { id: 'Rabba', name: 'Rabba' },
          { id: 'Cantor', name: 'Cantor' },
          { id: 'Shomer', name: 'Shomer' },
        ]}/>
        <TextInput source="name" validate={[required()]} />
        <TextInput source="address" />
        <TextInput source="city" />
        <TextInput source="state" />
        <TextInput source="postal_code" />
        <BooleanInput source="active" defaultValue={true} />
      </SimpleForm>
    </Create>
  );
  